import React from 'react';

import { RouteComponentProps } from '@reach/router';
import { isMobile } from 'react-device-detect';
import { Grid } from '@material-ui/core';

import { IAdminEvent } from '../../../../store/admin/events/store';

import EventAdminCard from '../../../../components/EventAdminCard/EventAdminCard';

interface IProps extends RouteComponentProps {
  eventsByMonth: {
    [month: string]: IAdminEvent[];
  };
}

const allMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const SeasonList = ({ eventsByMonth }: IProps) => (
  <div className="season-list">
    <div className="admin-wrapper">
      <Grid className="grid" container={true} spacing={8}>
        {Object.keys(eventsByMonth)
          .sort((a: string, b: string) => allMonths.indexOf(b) - allMonths.indexOf(a))
          .map(month =>
            eventsByMonth[month].map((event: IAdminEvent, index: number) => (
              <Grid key={event.id} className="grid-item" item={true} xs={12} md={6} lg={4}>
                <h2 className={`month-label`} hidden={index !== 0 && isMobile}>
                  {index === 0 ? month : ' '}
                </h2>
                <EventAdminCard event={event} />
              </Grid>
            ))
          )}

        {!Object.keys(eventsByMonth).length && (
          <Grid className="grid-item" item={true} xs={12}>
            <h2 className="no-events">THERE ARE NO EVENTS TO SHOW IN THIS SEASON</h2>
          </Grid>
        )}
      </Grid>
    </div>
  </div>
);

export { SeasonList };
